// src/components/Header.js
import LogoutButton from '../components/LogoutButton';
import { Stack, Typography, IconButton, Box } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';

const Header = ({ userName, onMenuClick }) => {
  return (
    <header style={{ padding: '10px 20px' }}>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="flex-end"
      >
        <IconButton
          color="inherit"
          edge="start"
          onClick={onMenuClick}
          sx={{
            display: { md: 'none' },
            position: 'fixed',
            top: 12,
            left: 12,
            zIndex: theme => theme.zIndex.drawer + 1,
          }}
        >
          <MenuIcon />
        </IconButton>
        <Box sx={{ flexGrow: 1, display: { md: 'none' } }} />
        <Stack direction="row" spacing={1} alignItems="center">
          <AccountCircleIcon color="primary" />
          <Typography variant="body1">
            {userName}
          </Typography>
        </Stack>

        <LogoutButton />

      </Stack>
    </header>
  );
};

export default Header;
